/* istanbul ignore file */ /* plugin extension code */
export * from './intlPolyfill';
